import {BusinessController} from "@/controllers/business/BusinessController";

export class BusinessService {

    static async downloadPdf(business, type, creditNoteNumber) {
        let resp;
        if (type === 'invoice') {
            resp = await BusinessController.getInvoicePdf(business.id);
        } else if (type === 'quote') {
            resp = await BusinessController.getQuotePdf(business.id);
        } else if (type === 'deposit') {
            resp = await BusinessController.getDepositPdf(business.id);
        } else if (type === 'creditNote') {
            resp = await BusinessController.getCreditNotePdf(creditNoteNumber);
        }

        if (resp) {
            const url = URL.createObjectURL(resp);
            const a = document.createElement('a');
            const cleanTitle = business.title ? business.title.replaceAll(' ', '_').replace(/[<>:|?*\\]/g, '') : '';
            a.href = url;
            a.download = `${type === 'invoice' ? `Facture_${business.invoiceNumber}` : type === 'quote' ? `Devis_${business.number}` : type === 'deposit' ? `Acompte_${business.number}` : type === 'creditNote' ? `Avoir_${creditNoteNumber}` : ""}_${cleanTitle}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
        }
    }

}